import { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import { ROUTE_PATHS, type Lang } from '@/lib/index';

export default function App() {
  const [lang, setLang] = useState<Lang>('ca');

  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <Layout lang={lang} onLangChange={setLang}>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home lang={lang} />} />
          </Routes>
        </Layout>
      </Router>
    </MotionConfig>
  );
}
